export enum AnalyticsPermissionEnum {
  READ = 'read',
  EDIT = 'edit',
}
